var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColorIcoDel19(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 1.58333C13.8653 1.58333 17.4167 5.13475 17.4167 9.5C17.4167 13.8653 13.8653 17.4167 9.5 17.4167C5.13475 17.4167 1.58333 13.8653 1.58333 9.5C1.58333 5.13475 5.13475 1.58333 9.5 1.58333ZM9.5 0C4.25363 0 0 4.25363 0 9.5C0 14.7464 4.25363 19 9.5 19C14.7464 19 19 14.7464 19 9.5C19 4.25363 14.7464 0 9.5 0ZM14.25 13.0926L10.6147 9.49208L14.2136 5.86071L13.0926 4.75L9.49446 8.38296L5.86229 4.78642L4.75 5.89871L8.38613 9.50238L4.78642 13.1377L5.89871 14.25L9.50475 10.6115L13.1393 14.2136L14.25 13.0926Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 9.5,
    y1: 0,
    x2: 9.5,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62CEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D8CBB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorIcoDel19);
export default __webpack_public_path__ + "static/media/color-ico-del-19.8eb936ea8ba828f233ade1fef143c613.svg";
export { ForwardRef as ReactComponent };